import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { PureComponent } from 'react';
import { PieChart, Pie, ResponsiveContainer, Tooltip, Cell
// Sector,
// LabelList,
} from 'recharts';
import { TRANSACTION_TYPESV2, TRANSACTION_TYPES, PIE_CHART_COLORS_PALETTE } from 'src/constants/payments';
import { hex2rgba, getStringHash, getColorFromHashAndPalette } from 'src/utils/colors';
const renderActiveShape = props => {
  var _TRANSACTION_TYPES$na;
  const RADIAN = Math.PI / 180;
  const cx = props.cx,
    cy = props.cy,
    midAngle = props.midAngle,
    outerRadius = props.outerRadius,
    percent = props.percent,
    value = props.value,
    name = props.name;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const mx = cx + (outerRadius + 5) * cos;
  const ex = mx + (cos >= 0 ? 1 : -1) * 10;
  const ey = cy + (outerRadius + 30) * sin + (sin >= 0.99 ? 3 : 0 || sin <= -0.99 ? -3 : 0);
  const textAnchor = cos >= 0 ? sin >= 0.99 ? 'middle' : 'start' : sin <= -0.99 ? 'middle' : 'end';
  const labelTextShift = 5;
  return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: ex + (cos >= 0 ? 1 : -1) * labelTextShift,
    y: ey,
    textAnchor: textAnchor,
    fill: "#333",
    style: {
      fontSize: '14px',
      overflowWrap: 'break-word'
    }
  }, "".concat((_TRANSACTION_TYPES$na = TRANSACTION_TYPES[name]) !== null && _TRANSACTION_TYPES$na !== void 0 ? _TRANSACTION_TYPES$na : name)), /*#__PURE__*/React.createElement("text", {
    x: ex + (cos >= 0 ? 1 : -1) * labelTextShift,
    y: ey,
    dy: 13,
    textAnchor: textAnchor,
    fill: '#606060',
    style: {
      fontSize: '12'
    }
  }, "$".concat(Number(value).toFixed(2), " / ").concat((percent * 100).toFixed(2), "%")));
};
const CustomTooltip = _ref => {
  let active = _ref.active,
    payload = _ref.payload;
  if (active && payload && payload.length) {
    var _payload$, _payload$2, _payload$3, _payload$4, _payload$5, _payload$6;
    return /*#__PURE__*/React.createElement("div", {
      // className={classes.customTooltip}
      style: {
        backgroundColor: 'hsla(0,0%,100%,0.9)',
        border: '1px solid #f5f5f5',
        padding: '5px',
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "label",
      style: {
        padding: 0,
        margin: 0,
        color: (_payload$ = payload[0]) === null || _payload$ === void 0 ? void 0 : _payload$.payload.fill
      }
    }, "".concat(((_payload$2 = payload[0]) === null || _payload$2 === void 0 || (_payload$2 = _payload$2.payload) === null || _payload$2 === void 0 ? void 0 : _payload$2.chargeType) === TRANSACTION_TYPESV2.UtilityCharge ? (_payload$3 = payload[0]) === null || _payload$3 === void 0 || (_payload$3 = _payload$3.payload) === null || _payload$3 === void 0 ? void 0 : _payload$3.utilityTypeName : TRANSACTION_TYPES[(_payload$4 = payload[0]) === null || _payload$4 === void 0 || (_payload$4 = _payload$4.payload) === null || _payload$4 === void 0 ? void 0 : _payload$4.chargeType])), /*#__PURE__*/React.createElement("p", {
      // className={classes.descTotalCurrency}
      style: {
        padding: 0,
        margin: 0
      }
    }, "Total: $", "".concat(Number((_payload$5 = payload[0]) === null || _payload$5 === void 0 || (_payload$5 = _payload$5.payload) === null || _payload$5 === void 0 ? void 0 : _payload$5.unpaid).toFixed(2))), /*#__PURE__*/React.createElement("p", {
      // className={classes.descTotalPersentage}
      style: {
        padding: 0,
        margin: 0
      }
    }, "Total share: ", "".concat(Number((_payload$6 = payload[0]) === null || _payload$6 === void 0 || (_payload$6 = _payload$6.payload) === null || _payload$6 === void 0 ? void 0 : _payload$6.percentageOfTotalUnpaid).toFixed(2), "%")));
  }
  return null;
};
export default class PieChartUnpaid extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      activeIndex: 0
    });
    _defineProperty(this, "onPieEnter", (_, index) => {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        activeIndex: index
      }));
    });
    this.state = _objectSpread(_objectSpread({}, props), {}, {
      activeIndex: 0
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(ResponsiveContainer, null, /*#__PURE__*/React.createElement(PieChart, {
      width: '50%',
      height: '50%'
    }, /*#__PURE__*/React.createElement(Pie, {
      data: this.props.data,
      cx: "50%",
      cy: "50%",
      innerRadius: 15,
      outerRadius: 42,
      fill: '#ff5e5e',
      dataKey: "value",
      onMouseEnter: this.onPieEnter
      // onMouseLeave={(_, index) => this.onPieEnter(_, undefined)}
      // label={renderLabel}
      ,
      label: renderActiveShape,
      paddingAngle: 3,
      minAngle: 25,
      isAnimationActive: false
    }, this.props.data.map((entry, index) => /*#__PURE__*/React.createElement(Cell, {
      isAnimationActive: false,
      key: "cell-".concat(index),
      fill: hex2rgba(getColorFromHashAndPalette(getStringHash(entry.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? entry.utilityTypeName : entry.chargeType), PIE_CHART_COLORS_PALETTE), 0.75)
      // style={{ fontSize: '8px' }}
    }))), /*#__PURE__*/React.createElement(Tooltip, {
      content: /*#__PURE__*/React.createElement(CustomTooltip, null),
      cursor: {
        fill: 'transparent'
      }
    })));
  }
}